type SearchParamValue = string | number | boolean | null | undefined;

type SearchParamNames<TParams extends object> = {
    [Key in keyof TParams]: string;
};

type SearchParamReadNames<TParams extends object> = {
    [Key in keyof TParams]: string | readonly string[];
};

const getFirstSearchParamValue = (searchParams: URLSearchParams, names: string | readonly string[]) => {
    const searchNames = Array.isArray(names) ? names : [names];

    for (const name of searchNames) {
        const value = searchParams.get(name);

        if (value !== null) {
            return value;
        }
    }

    return undefined;
};

export const getSearchParamsValues = <TParams extends object>(
    searchParams: URLSearchParams,
    paramNames: SearchParamReadNames<TParams>,
) => {
    const values = {} as TParams;

    Object.keys(paramNames).forEach((key) => {
        const paramKey = key as keyof TParams;
        const value = getFirstSearchParamValue(searchParams, paramNames[paramKey]);

        if (value !== undefined) {
            values[paramKey] = value as TParams[keyof TParams];
        }
    });

    return values;
};

export const createUrlWithSearchParams = <TParams extends object>(
    route: string,
    values: TParams,
    paramNames: SearchParamNames<TParams>,
) => {
    const searchParams = new URLSearchParams();

    Object.keys(paramNames).forEach((key) => {
        const paramKey = key as keyof TParams;
        const value = values[paramKey] as SearchParamValue;

        if (value === undefined || value === null || value === '') {
            return;
        }

        searchParams.set(paramNames[paramKey], String(value));
    });

    const query = searchParams.toString();

    return query ? `${route}?${query}` : route;
};
